interface AllergensList {
  img: string;
  name_es: string;
  name_en: string;
  name_fr: string;
}

export const allergensList: Record<string, AllergensList> = {
  altramuces: {
    img: '/img/allergens/altramuces.svg',
    name_es: 'altramuces',
    name_en: 'lupins',
    name_fr: 'lupins'
  },
  apio: {
    img: '/img/allergens/apio.svg',
    name_es: 'apio',
    name_en: 'celery',
    name_fr: 'céleri'
  },
  cacahuetes: {
    img: '/img/allergens/cacahuetes.svg',
    name_es: 'cacahuetes',
    name_en: 'peanuts',
    name_fr: 'arachides'
  },
  crustaceos: {
    img: '/img/allergens/crustaceos.svg',
    name_es: 'crustaceos',
    name_en: 'crustaceans',
    name_fr: 'crustacés'
  },
  huevos: {
    img: '/img/allergens/huevos.svg',
    name_es: 'huevos',
    name_en: 'eggs',
    name_fr: 'oeufs'
  },
  lacteo: {
    img: '/img/allergens/lacteo.svg',
    name_es: 'lácteo',
    name_en: 'dairy',
    name_fr: 'lait'
  },
  molusco: {
    img: '/img/allergens/molusco.svg',
    name_es: 'molusco',
    name_en: 'molluscs',
    name_fr: 'mollusques'
  },
  mostaza: {
    img: '/img/allergens/mostaza.svg',
    name_es: 'mostaza',
    name_en: 'mustard',
    name_fr: 'moutarde'
  },
  'frutos con cáscara': {
    img: '/img/allergens/frutos con cáscara.svg',
    name_es: 'frutos con cáscara',
    name_en: 'nuts with shell',
    name_fr: 'fruits à coque'
  },
  pescado: {
    img: '/img/allergens/pescado.svg',
    name_es: 'pescado',
    name_en: 'fish',
    name_fr: 'poisson'
  },
  sesamo: {
    img: '/img/allergens/sesamo.svg',
    name_es: 'sésamo',
    name_en: 'sesame',
    name_fr: 'sésame'
  },
  soja: {
    img: '/img/allergens/soja.svg',
    name_es: 'soja',
    name_en: 'soy',
    name_fr: 'soja'
  },
  gluten: {
    img: '/img/allergens/gluten.svg',
    name_es: 'gluten',
    name_en: 'gluten',
    name_fr: 'gluten'
  },
  sulfitos: {
    img: '/img/allergens/sulfitos.svg',
    name_es: 'sulfitos',
    name_en: 'sulfites',
    name_fr: 'sulfites'
  }
}
